export default __webpack_public_path__ + "static/media/eye.766486d6.svg";